import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'coupon',
    serviceName: 'auth',
    query: gql`
      query coupon($ids: [String], $for_admin: Int) {
        coupon(ids: $ids, for_admin: $for_admin) {
          data {
            shop {
              id
              title
            }
            users {
              id
              lastname
              firstname
              cellphone
              media {
                full_url
              }
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'unsetCouponUser',
    serviceName: 'unitadmin',
    query: gql`
      mutation unsetCouponUser($coupon_id: String!, $user_ids: [String]!) {
        unsetCouponUser(coupon_id: $coupon_id, user_ids: $user_ids) {
          messages
        }
      }
    `,
  },
};

export default schema;
